import type z from "zod";

import { zSchema } from "../../../../entity";

const zIn = zSchema.omit({
  id: true,
  adminComment: true,
  createdAt: true,
  isResolved: true,
});
type In = z.infer<typeof zIn>;

export { zIn };
export type { In };
